import { useContext } from 'react'

import { chatContext, type SendbirdContext } from '@/providers/ChatProvider'

export const useSendbird = (): SendbirdContext => useContext(chatContext)
